const CONSTANTS = {
  WELCOME_MSG: "welcome_msg",
  COMPONENT_LIST_MSG: "component_list_msg",
  DEFAULT_MSG: "default_msg",
  PROFILE_MSG: "profile_msg",
  SETTINGS: "settings",
  PROFILE: "profile",
  LOGOUT: "logout",
  THEME: "theme",
  SXP_TITLE: "Welcome to TSF React base project",
  SXP_SUBTITLE: "Service eXperience Platform",
  SXP_DEFAULT_MSG: "Hi, Welcome To React Template Project",
  VERSION_ID: "WORKING",
  COULDNT_UPLOAD_DOC: "Could not upload Document",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  BUSINESS_USER: "business-user",
  SELECT_START_END_DATE: "Select start date and end date",
  USER_EMAIL: "user-email",
  FIRST_NAME: "first-name",
  LAST_NAME: "last-name",
  USER_ID: "user-id",
  REACT_TOKEN: "react-token",
  USER_TYPE: "user-type",
  COUNTRY: "country",
  I18NEXTLNG: "i18nextLng",
};
export const PAGE_COUNT_LIST = [10, 20, 30];

export const AUTH_SERVER_URL = process.env?.REACT_APP_KEYCLOAK_URL || "";
export const CLIENT_ID = process.env?.REACT_APP_KEYCLOAK_CLIENT_ID || "";
export const REALM = process.env?.REACT_APP_KEYCLOAK_REALM || "";
export const ERROR_OCCURED = "An error occurred";
export const WELCOME_MESSASGE = "Welcome to Awgment! How can I assist you ?";
export const CHAT_ERROR = "Invalid response format.";
export const TRY_AGAIN = "Oops! Something went wrong. Please try again.";
export const FAILED_BI_AUTOMATION = "Failed to fetch BI Automation Data:";
export const ERROR_BI_AUTOMATION = "Error fetching BI Automation Data:";
export const ASSET_DOWNLOAD_FAILED = "Failed to download asset";
export const DELETE_BI_DATA = "Error deleting BI record:";
export const ERROR_PROCESS_BI = "Error processing BI Automation:";
export const UNKNOWN_ERROR = "Unknown error";
export const UNEXPECTED_BI_ERROR = "Unexpected error processing BI Automation:";
export const FAILED_QA_AUTOMATION = "Failed to fetch QA Automation Data:";
export const QA_AUTOMATION_ERROR = "Error fetching QA Automation Data:";
export const DELETE_QA_DATA = "Error deleting QA record:";
export const ERROR_PREVIEW_ASSET = "Error previewing asset:";
export const ERROR_PROCESS_QA = "Error processing QA Automation:";
export const UNEXPECTED_QA_ERROR = "Unexpected error processing QA Automation:";
export const ERROR_DELETION = "Error during deletion:";
export const ERROR_GENERATING_RESPONSE = "Error generating response:";
export const ERROR_DOWNLOAD_ASSET = "Error downloading asset:";
export const PDF_GENERATED = "PDF generation initiated successfully";
export const FALIED_PDF = "Failed to initiate PDF generation";
export const UNEXPECTED_ERROR = "An unexpected error occurred";
export const ERROR_FILE_TYPES = "Error fetching file types:";
export const FILE_REQUIRED = "File is required.";
export const DATABASE_CONNECTED = "Database connection created successfully";
export const FILE_UPLOADED = "File uploaded successfully";
export const UPLOAD_FAILED = "Upload failed";
export const ERROR_FETCH_DATA = "Error fetching database connection data:";
export const INVALID_FORMAT = "Invalid response format.";
export const ERROR_OPEN_FILE = "Error opening file: ";
export const ASSET_TYPE = "Asset type is required.";
export const PROJECT_NAME = "Project name is required.";
export const PREVIEW_SUCCESS = "Preview successfull";
export const ASSET_SUCCESS = "Asset name updated successfully";
export const UPDATE_FAIL = "Failed to update asset name";
export const ERROR_EDIT = "Error editing asset name:";
export const PREVIEW_FAIL = "Preview Failed";
export const PROCESS_SUCCESS = "Processing successful";
export const PROCESS_FAIL = "Failed to process request";
export const FAILED_PSEUDO_CODE = "Falied to load Pseudo code";
export const PSEUDO_DELETE = "Asset deleted successfully";
export const PSEUDO_FAIL = "Failed to delete asset";
export const DELETE_PSEUDO_DATA = "Pseudo code data deleted successfully";
export const DELETE = "delete";
export const DOWNLOAD = "download";
export const INTERACT = "interact";
export const PREVIEW = "preview";
export const DATABASE = "DATABASE";
export const LOGIN_ACCESS_ERROR="You do not have the required permissions";
export const AUTHENTICATION_ERROR="Authentication failed. Please check your credentials"

export default CONSTANTS;
